import { useCallback } from "react";

import type { Amenity } from "@/lib/gql/__generated__/graphql";

import { useAccommodationHotelPolicyFormModelContext } from "@/components/features/items/edit/hotel-policy/default/ui/context";

export const useAmenitiesOfHotelPolicy = () => {
	const { viewModel, onSetViewModel } = useAccommodationHotelPolicyFormModelContext();
	const { amenities } = viewModel;

	const updateAmenities: (checked: boolean, amenity: Amenity) => void = useCallback(
		(checked, amenity) => {
			const newAmenities = {
				...amenities,
			};

			if (checked) {
				newAmenities.value.push({ value: amenity, isEdited: false });
			} else {
				newAmenities.value = amenities.value.filter(({ value }) => value !== amenity);
			}

			onSetViewModel([{ key: "amenities", value: newAmenities }]);
		},
		[amenities, onSetViewModel],
	);

	return {
		amenities,
		updateAmenities,
	};
};
